import Vue from "vue";
import BannerContainer from "@/BannerContainer.vue";
import CelebrusHubOffres from "./components/CelebrusHubOffres.vue";
import { MainEvent } from "@/classes/MainEvent";
import { gabs } from "./config/exclusionList";
import "@/styles/main.scss";

Vue.config.productionTip = false;
function bannerLauncher(payload) {
  const banner = new MainEvent(payload);
  let placement: Element|string  = `#${banner.placement.id}`;
  if ( banner.placement.id === "celebrus-hub-offres" && !!document.querySelector(".celebrus-hub-offres-wrapper") ) {
    if ( document.querySelectorAll(".celebrus-hub-offres-wrapper > div").length < 3 ) {
      const newOffre = document.createElement("div");
      document.querySelector("#celebrus-hub-offres .celebrus-hub-offres-wrapper").append(newOffre);
      placement = newOffre;
      new Vue({
        render: (createElement) => createElement(CelebrusHubOffres, { props: { banner } })
      }).$mount(placement);
    }
  } else {
    new Vue({
      render: (createElement) => createElement(BannerContainer, { props: { banner } })
    }).$mount(placement);
  }
}

const emplacements = ["cg-promo",
                      "fiche-produit",
                      "hb-hub",
                      "hb-rop",
                      "menu-notre-offre",
                      "menu-notre-offre-2",
                      "vignettes-fiche-produit",
                      "mon-offre",
                      "hb-popin",
                      "hb-messagerie",
                      "hb-alerte",
                      "confirmation-virement",
                      "side-animation",
                      "side-rebond",
                      "hub-offres"
                    ];

emplacements.forEach((emplacement) => {
  window.addEventListener(
    "rtim-banner:celebrus-" + emplacement,
    (event: any) => {
      console.log( `Event recieved for celebrus-${emplacement}:`, event, "payload: ", event.detail );
      // Only if not from exclusion list
      const gabName = event.detail.content.nom_gabarit;
      const targetEmpty = !document.querySelectorAll(`#${event.detail.placement.id} *`).length;
      const forceDispatch = event.detail.content.emplacement === "celebrus-hub-offres" ||
                            !!event.detail.content.forceDispatch;

      if (!!event.detail.content.banniere_temoins) {
        event.detail.celebrusHelper.extended();
      } else {
        if (!gabs.includes(gabName) && (targetEmpty || forceDispatch) || gabName === "Gab20") {

          bannerLauncher(event.detail);
        } else {
          console.log("no dispatch for " + event.detail.content.emplacement);
        }
      }
    },
    false
  );
});
